import { z } from 'zod'

import { AiIntentSchema } from 'shared/api/requests/aiIntents/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const AiIntentsSocketEventsSchemas = {
  intentCreated: SocketEventBaseSchema.extend({
    event: z.literal('ai_intent_created'),
    model: AiIntentSchema,
  }),

  intentUpdated: SocketEventBaseSchema.extend({
    event: z.literal('ai_intent_updated'),
    model: AiIntentSchema,
  }),

  intentDeleted: SocketEventBaseSchema.extend({
    event: z.literal('ai_intent_deleted'),
    model: z.object({
      intent_id: z.number(),
    }),
  }),
}
